module.exports = __webpack_public_path__ + "static/media/logo-usfa-big.fdf129d4.png";